/**
 * Pop Mart PDP upsell (snippets/popmart-bundle-upsell.liquid)
 *
 * Mirrors the Essentials bundle-builder UX for products without a bundle
 * metaobject: the builder shows the CURRENT product's variant group first
 * (kept in sync with the main variant selector), then a picker fed by
 * Shopify's native product recommendations (popmart-upsell-items section);
 * picking a candidate reveals its variant group. Selecting a variant in both
 * groups arms the "add set" CTA, which adds the pair in one /cart/add.js call.
 *
 * Pricing: -10% automatic discount on 2+ Pop Mart items (fixed — there is no
 * metaobject config for Pop Mart), so the CTA shows the post-discount total.
 * The module hides itself once the cart already holds 2+ Pop Mart items.
 */
(function () {
  if (window.__popmartUpsellInit) return;
  window.__popmartUpsellInit = true;

  var formatMoney = function (cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + '€';
  };

  function init() {
    // Two instances per PDP: desktop (inside the inline buy box) and mobile
    // (its own wrapper) — wire each independently.
    document.querySelectorAll('[data-popmart-upsell]').forEach(initRoot);
  }

  function initRoot(root) {
    var trigger = root.querySelector('[data-popmart-trigger]');
    var builder = root.querySelector('[data-popmart-builder]');
    var pickerList = root.querySelector('[data-popmart-picker-list]');
    var candidatesSlot = root.querySelector('[data-popmart-candidates-slot]');
    var currentGroup = builder.querySelector('.bundle-builder__product:not([data-candidate])');
    var atc = root.querySelector('[data-popmart-atc]');
    var atcTotal = root.querySelector('[data-popmart-atc-total]');
    var note = root.querySelector('[data-popmart-note]');
    var noteBase = note ? note.textContent.trim() : '';
    var pct = parseFloat((root.dataset.discountLabel || '').replace(/[^0-9.]/g, '')) || 0;

    var currentPick = null; // { variantId, price } — current product's variant
    var candPick = null; // { variantId, price } — picked recommendation's variant
    var loaded = false;

    // Keep the current product's group in sync with the main variant selector.
    // The .sticky-variant-btn-grid buttons carry the option label
    // (data-option-value), not a variant id, so we match by label — the same
    // mechanism the Essentials builder uses (syncCurrentProductSize).
    function matchByLabel(label) {
      if (!currentGroup || !label) return null;
      var btns = currentGroup.querySelectorAll('.bundle-builder__size-btn:not([disabled])');
      for (var i = 0; i < btns.length; i++) {
        if (btns[i].textContent.trim() === label) return btns[i];
      }
      return null;
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.sticky-variant-btn-grid');
      if (!btn) return;
      var match = matchByLabel((btn.dataset.optionValue || '').trim());
      if (match && !match.classList.contains('is-selected')) selectVariant(match);
    });

    function syncFromMainSelector() {
      if (!currentGroup) return;
      var mainSel = document.querySelector('.sticky-variant-btn-grid.is-selected');
      var match = mainSel ? matchByLabel((mainSel.dataset.optionValue || '').trim()) : null;
      if (match && !match.classList.contains('is-selected')) {
        selectVariant(match);
        return;
      }
      // No main selection: auto-select when the product has a single variant.
      autoSelectSingle(currentGroup);
    }

    function autoSelectSingle(group) {
      if (!group) return;
      var enabled = group.querySelectorAll('.bundle-builder__size-btn:not([disabled])');
      if (enabled.length === 1 && !enabled[0].classList.contains('is-selected')) {
        selectVariant(enabled[0]);
      }
    }

    function update() {
      var ready = !!(currentPick && candPick);
      atc.disabled = !ready;
      if (!ready) {
        if (atcTotal) atcTotal.textContent = '';
        if (note) note.textContent = noteBase;
        document.dispatchEvent(new CustomEvent('installments:bundle-total', { detail: { source: 'popmart', cents: null } }));
        return;
      }
      var gross = currentPick.price + candPick.price;
      var net = pct > 0 ? Math.round(gross * (1 - pct / 100)) : gross;
      if (atcTotal) atcTotal.textContent = ' · ' + formatMoney(net);
      // Installment widgets quote the discounted set price while the set is complete.
      document.dispatchEvent(new CustomEvent('installments:bundle-total', { detail: { source: 'popmart', cents: net } }));
      if (note) {
        var tpl = root.dataset.youSaveTpl || '';
        note.textContent = tpl
          ? noteBase + ' · ' + tpl.replace('[AMT]', formatMoney(gross - net))
          : noteBase;
      }
    }

    function loadRecommendations() {
      if (loaded) return;
      loaded = true;
      var url = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
      url += 'recommendations/products?section_id=popmart-upsell-items&product_id=' + root.dataset.productId + '&limit=10';
      fetch(url)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var tpl = document.createElement('template');
          tpl.innerHTML = html;
          var items = tpl.content.querySelectorAll('[data-popmart-picker-items] .bundle-builder__picker-item');
          var groups = tpl.content.querySelectorAll('[data-popmart-candidates] .bundle-builder__product');
          if (!items.length) {
            root.hidden = true; // nothing to recommend — remove the module
            return;
          }
          items.forEach(function (item) { pickerList.appendChild(item); });
          groups.forEach(function (group) { candidatesSlot.appendChild(group); });
          // Pre-select the first recommendation, like the paired-item default.
          selectItem(pickerList.querySelector('.bundle-builder__picker-item'));
        })
        .catch(function (err) {
          console.error('Pop Mart upsell: recommendations fetch failed', err);
          root.hidden = true;
        });
    }

    // Picker: choosing a product reveals its variant group (Single Box / Set),
    // exactly like the Essentials builder; the variant click below arms the CTA.
    function selectItem(item) {
      if (!item) return;
      pickerList.querySelectorAll('.bundle-builder__picker-item.is-selected').forEach(function (b) {
        b.classList.remove('is-selected');
      });
      item.classList.add('is-selected');
      item.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      candPick = null;
      var targetId = item.dataset.pickerTarget;
      var activeGroup = null;
      candidatesSlot.querySelectorAll('[data-candidate]').forEach(function (g) {
        var active = g.dataset.builderProductId === targetId;
        g.hidden = !active;
        if (!active) {
          g.querySelectorAll('.bundle-builder__size-btn.is-selected').forEach(function (b) { b.classList.remove('is-selected'); });
        } else {
          activeGroup = g;
        }
      });
      update();
      // Single-variant candidates (Single Box only): auto-select the variant
      // so the CTA arms in one tap; multi-variant waits for an explicit pick.
      autoSelectSingle(activeGroup);
    }

    function selectVariant(btn) {
      var group = btn.closest('.bundle-builder__product');
      group.querySelectorAll('.bundle-builder__size-btn.is-selected').forEach(function (b) { b.classList.remove('is-selected'); });
      btn.classList.add('is-selected');
      var picked = { variantId: btn.dataset.variantId, price: parseInt(btn.dataset.variantPrice, 10) || 0 };
      if (group === currentGroup) { currentPick = picked; } else { candPick = picked; }

      // Delivery note, mirroring the bundle builder (preorder prefix links to
      // the pre-order conditions page).
      var noteEl = group.querySelector('[data-delivery-note]');
      var textEl = group.querySelector('[data-delivery-text]');
      if (noteEl && textEl) {
        var inStock = btn.dataset.inStock === 'true';
        noteEl.classList.remove('bundle-promotion--hidden');
        noteEl.classList.toggle('is-preorder', !inStock);
        var full = inStock ? (group.dataset.instockText || '') : (group.dataset.preorderText || '');
        var idx = inStock ? -1 : full.indexOf(':');
        textEl.textContent = '';
        if (idx === -1) {
          textEl.textContent = full;
        } else {
          var link = document.createElement('a');
          link.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'pages/pre-order';
          link.className = 'bundle-builder__preorder-link';
          link.textContent = full.slice(0, idx);
          textEl.appendChild(link);
          textEl.appendChild(document.createTextNode(full.slice(idx)));
        }
      }
      update();
    }

    trigger.addEventListener('click', function () {
      builder.classList.toggle('bundle-promotion--hidden');
      if (!builder.classList.contains('bundle-promotion--hidden')) {
        loadRecommendations();
        syncFromMainSelector();
        builder.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    });

    builder.addEventListener('click', function (e) {
      var item = e.target.closest('.bundle-builder__picker-item');
      if (item) { selectItem(item); return; }
      var sizeBtn = e.target.closest('.bundle-builder__size-btn');
      if (sizeBtn && !sizeBtn.disabled) selectVariant(sizeBtn);
    });

    atc.addEventListener('click', function () {
      if (!currentPick || !candPick) return;
      atc.disabled = true;
      atc.classList.add('is-loading');
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [
            { id: parseInt(currentPick.variantId, 10), quantity: 1 },
            { id: parseInt(candPick.variantId, 10), quantity: 1 }
          ]
        })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('popmart set add failed: ' + res.status);
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:item-added'));
          var drawer = document.getElementById('Cart-Drawer');
          if (drawer) {
            document.body.classList.add('open-cc');
            drawer.classList.add('active');
          }
          builder.classList.add('bundle-promotion--hidden');
        })
        .catch(function (err) {
          console.error('Pop Mart upsell: add set failed', err);
        })
        .then(function () {
          atc.classList.remove('is-loading');
          update();
        });
    });

    // Hide the module once the -10% is already secured (2+ Pop Mart items in
    // cart), mirroring the bundle congrats suppression; re-check on cart events.
    function checkCart() {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var qty = cart.items.reduce(function (acc, item) {
            return acc + (item.vendor === 'Pop Mart' ? item.quantity : 0);
          }, 0);
          root.hidden = qty >= 2;
        })
        .catch(function () { /* leave visibility as is */ });
    }
    ['cart:item-added', 'cart:updated', 'cart:refresh', 'cart:cleared', 'line-item:change:end'].forEach(function (ev) {
      document.addEventListener(ev, checkCart);
    });
    checkCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
